export default {
  actions: {
    copied: "Копирано в клипборда",
    copyFailed: "Неуспешно копиране",
    channelStarted: "{channelName} е стартиран успешно",
    channelStartFailed: "Неуспешно стартиране на {channelName}",
    channelStopped: "{channelName} е спрян успешно",
    channelStopFailed: "Неуспешно спиране на {channelName}",
    cacheCleared: "Кешът на Iris Core е изчистен успешно",
    cacheClearFailed: "Неуспешно изчистване на кеша на Iris Core",
  },

  tooltips: {
    copyBarcode: "Копирайте баркодa в клипборда",
  },
};
